<fieldset class="border-navyBlue">
  <!--notificationImportanceLevel name-->
  <legend class="bg-navyBlue">
    {{ notificationImportanceLevel.value }}
  </legend>

  <!--info div-->
  <div>
    <div class="tw-mt-5 row document-info tw-justify-center">
      <div class="tw-w-full">
        <!--fromDaysMoreThanSendFrequently-->
        <form-field
          type="number"
          class="tw-w-full"
          label="common.fromDaysMoreThanSendFrequently"
          [value]="modelItems[counter]?.fromDaysMoreThanSendFrequently || null"
          (valueChange)="
            model.fromDaysMoreThanSendFrequently = $event; emitItems()
          "
        >
        </form-field>
      </div>
      <!--toDaysMoreThanSendFrequently-->
      <div class="tw-w-full">
        <form-field
          type="number"
          class="tw-w-full"
          label="common.toDaysMoreThanSendFrequently"
          [value]="modelItems[counter]?.toDaysMoreThanSendFrequently || null"
          (valueChange)="
            model.toDaysMoreThanSendFrequently = $event; emitItems()
          "
        >
        </form-field>
      </div>
    </div>
  </div>
</fieldset>
